var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex",attrs:{"id":"app"}},[(!_vm.isSingle && _vm.isLogin)?_c('jc-header'):_vm._e(),(!_vm.isSingle && _vm.loadPage)?_c('div',{staticClass:"content",class:{full: !_vm.isSideBarShow}},[_c('jc-navbar'),_c('div',{staticClass:"main-container"},[_c('router-view')],1)],1):_c('router-view'),_c('loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }